import axios from '../getAxios';
import { passwordResetConfirmPayloadProps } from '../types';

export default async (payload: passwordResetConfirmPayloadProps) => {
  const { data } = await axios({
    method: 'POST',
    url: '/api/auth/password-reset/confirm',
    data: payload,
  });
  return data;
};
